(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-cart-recovery"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('DukantyMobileCartRecovery');
    if (!dialog || dialog.dataset.bound === 'true') return;
    dialog.dataset.bound = 'true';

    const mobile = window.matchMedia('(max-width: 749px) and (pointer: coarse)');
    if (!mobile.matches || !('showModal' in dialog)) return;

    const suppressionKey = 'dukanty_cart_recovery_last_seen';
    const checkoutKey = 'dukanty_cart_recovery_checkout_started';
    const pageViewsKey = 'dukanty_cart_recovery_page_views';
    const suppressionMs = Number(dialog.dataset.suppressionDays || 30) * 86400000;
    const minSubtotal = Number(dialog.dataset.minSubtotal || 70000);
    const startedAt = Date.now();
    const blockedHandles = new Set([
      'kamila-set-pure-copper',
      'romaisaa-chic-necklace',
      'dana-chic-necklace',
      'piercing-stainless'
    ]);

    let hiddenAt = 0;
    let idleTimer;
    let isChecking = false;
    let checkoutStarted = false;

    const storage = {
      get(area, key) {
        try { return Number(area.getItem(key) || 0); } catch (_) { return 0; }
      },
      set(area, key, value) {
        try { area.setItem(key, String(value)); } catch (_) { /* Storage may be unavailable. */ }
      }
    };

    const previousViews = storage.get(sessionStorage, pageViewsKey);
    const pageViews = previousViews + 1;
    storage.set(sessionStorage, pageViewsKey, pageViews);

    const recentlyShown = () => Date.now() - storage.get(localStorage, suppressionKey) < suppressionMs;
    const recentlyStartedCheckout = () => Date.now() - storage.get(sessionStorage, checkoutKey) < 600000;

    function pushMetric(event, detail = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...detail });
    }

    async function fetchCart() {
      const root = dialog.dataset.rootUrl || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }

    function isEligible(cart) {
      if (!cart || cart.item_count < 1 || cart.total_price < minSubtotal) return false;
      if ((cart.cart_level_discount_applications || []).length) return false;

      return !cart.items.some((item) => {
        const hasDiscount = (item.discount_allocations || []).length > 0;
        return hasDiscount || blockedHandles.has(item.handle);
      });
    }

    function formatMoney(amount, currency) {
      try {
        return new Intl.NumberFormat(dialog.dataset.locale || 'en', {
          style: 'currency',
          currency: currency || 'EGP',
          maximumFractionDigits: 0
        }).format(amount / 100);
      } catch (_) {
        return `${Math.round(amount / 100)} ${currency || 'EGP'}`;
      }
    }

    function findWhatsAppUrl(message) {
      const selectors = [
        'a[href*="wa.me"]',
        'a[href*="api.whatsapp.com"]',
        'a[href*="web.whatsapp.com"]',
        'a[href*="whatsapp.com/send"]'
      ];
      try {
        const existing = document.querySelector(selectors.join(','));
        if (!existing) {
          const number = (dialog.dataset.whatsappNumber || '').replace(/\D/g, '');
          if (!number) return null;
          const directUrl = new URL(`https://wa.me/${number}`);
          directUrl.searchParams.set('text', message);
          return directUrl.toString();
        }

        const url = new URL(existing.href, window.location.origin);
        url.searchParams.set('text', message);
        return url.toString();
      } catch (_) {
        return null;
      }
    }

    function prepareCta(cart) {
      const items = cart.items.slice(0, 3).map((item) => `${item.quantity}× ${item.product_title}`).join(', ');
      const total = formatMoney(cart.total_price, cart.currency);
      const message = (dialog.dataset.messageTemplate || '')
        .replace('[total]', total)
        .replace('[items]', items)
        .replace('[url]', window.location.href);
      const cta = dialog.querySelector('[data-recovery-whatsapp]');
      const summary = dialog.querySelector('[data-recovery-summary]');
      const whatsappUrl = findWhatsAppUrl(message);

      summary.textContent = `${cart.item_count} · ${total}`;
      summary.hidden = false;

      if (whatsappUrl) {
        cta.href = whatsappUrl;
        cta.target = '_blank';
      } else {
        cta.href = dialog.dataset.contactUrl;
        cta.removeAttribute('target');
        cta.querySelector('span').textContent = dialog.dataset.contactLabel;
      }
    }

    async function considerOpening(reason) {
      if (isChecking || dialog.open || checkoutStarted || recentlyShown() || recentlyStartedCheckout()) return;
      if (Date.now() - startedAt < 15000) return;

      isChecking = true;
      try {
        const cart = await fetchCart();
        if (!isEligible(cart)) return;

        prepareCta(cart);
        storage.set(localStorage, suppressionKey, Date.now());
        dialog.showModal();
        pushMetric('dukanty_cart_recovery_impression', {
          recovery_reason: reason,
          cart_items: cart.item_count,
          cart_total: cart.total_price / 100
        });
      } catch (_) {
        /* The recovery experience should never interrupt shopping. */
      } finally {
        isChecking = false;
      }
    }

    function scheduleIdleCheck() {
      window.clearTimeout(idleTimer);
      const idleMs = pageViews > 1 ? 30000 : 45000;
      idleTimer = window.setTimeout(() => considerOpening('inactivity'), idleMs);
    }

    ['touchstart', 'pointerdown', 'keydown', 'scroll'].forEach((eventName) => {
      window.addEventListener(eventName, scheduleIdleCheck, { passive: true });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        hiddenAt = Date.now();
        return;
      }
      if (hiddenAt && Date.now() - hiddenAt >= 12000) considerOpening('returned_to_cart');
      hiddenAt = 0;
    });

    document.addEventListener('click', (event) => {
      const checkoutControl = event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (checkoutControl) {
        checkoutStarted = true;
        storage.set(sessionStorage, checkoutKey, Date.now());
      }

      if (event.target.closest('[data-recovery-whatsapp]')) {
        pushMetric('dukanty_cart_recovery_click', { recovery_action: 'support' });
      }

      if (event.target.closest('[data-recovery-dismiss]')) {
        pushMetric('dukanty_cart_recovery_click', { recovery_action: 'continue_shopping' });
        dialog.close();
      }
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    scheduleIdleCheck();
  })();
  } catch(e) { console.error(e); }
})();

})();
